import { ReactComponent as MinerStatusOk } from "@assets/redesign/icons/minerStatusOk.svg";
import { ReactComponent as MinerStatusLow } from "@assets/redesign/icons/minerStatusLow.svg";
import { ReactComponent as MinerStatusBad } from "@assets/redesign/icons/minerStatusBad.svg";
import cn from "classnames";
import Title from "@components/global/new/Title/Title";
import { useIntl } from "react-intl";
import { IMinersStatusesProps } from "./MinersStatuses.props";

import styles from "./MinersStatuses.module.scss";

export default function MinersStatuses({
  ok,
  low,
  off,
  showTitle = true,
  className,
  onClickStatuses,
}: IMinersStatusesProps) {
  const { formatMessage } = useIntl();

  return (
    <div className={cn(styles.wrapper, className)}>
      {showTitle && (
        <Title className={styles.title}>
          {formatMessage({ id: "menu.machines" })}:
        </Title>
      )}
      <div className={styles.content}>
        <div
          className={cn(styles.row, {
            [styles.cursor]: typeof onClickStatuses !== "undefined",
          })}
          onClick={() => onClickStatuses?.("ok")}
        >
          <MinerStatusOk title='Online' />
          {ok}
        </div>
        <div
          className={cn(styles.row, {
            [styles.cursor]: typeof onClickStatuses !== "undefined",
          })}
          onClick={() => onClickStatuses?.("low")}
        >
          <MinerStatusLow title='Low' />
          {low}
        </div>
        <div
          className={cn(styles.row, {
            [styles.cursor]: typeof onClickStatuses !== "undefined",
          })}
          onClick={() => onClickStatuses?.("offline")}
        >
          <MinerStatusBad title='Offline' />
          {off}
        </div>
      </div>
    </div>
  );
}
